// Shared wrapper around `el.call('openModal', { template: 'custom', ... })`
// — MODAL-X-OVERFLOW-1 root-layer fix.
//
// @symbo.ls/windows' ModalLayer.js deliberately sets `overflow: 'visible'`
// on the outer ModalWindow chrome and defaults `maxHeight` to `null` when a
// custom-template layer's own descriptor doesn't supply one (2026-06-03 —
// avoids the rounded-corner clip eating the Close X on `overflow: 'auto'`).
// The trade-off: every custom-template modal that skips `maxHeight` on its
// own `openModal` call has NO outer scroll containment. On a short viewport
// (or with unusually tall body content) the centered backdrop box overflows
// equally top and bottom, and the body's `ModalHeader` — with the Close X —
// is the first thing pushed off-screen. That reads as "the modal lost its
// close button", even though CloseButton itself renders correctly.
//
// `openCustomModal` supplies a safe default `maxHeight` so callers get
// correct outer containment for free; pass your own `maxHeight` to override
// per call (a few modals genuinely need more/less room). This only fixes
// the OUTER ceiling — the BODY component still needs its own scrollable
// region inside that ceiling (`flex: '1', minHeight: '0', overflow: 'auto'`
// on the content block that should scroll, with ModalHeader / a footer
// Actions row left OUTSIDE it so they stay pinned — see
// `chat/components/ChannelSettingsModal.js`'s Header/Content/Footer split,
// or `workspace/components/AppCreateOrgModal.js`'s Header/Fields/Actions
// split, for the canonical shape).
export function openCustomModal(opts = {}) {
  return this.call('openModal', {
    maxHeight: '90dvh',
    ...opts,
    template: 'custom'
  })
}
